import React from 'react';
import { OPTION_GROUP_CLASSNAME } from '@dashboard/components/Formik/components/optionGroupClass';
import Label from './Label';

const RadioGroup = ({ name, children }) => {
  return (
    <div role="radiogroup" aria-labelledby={name} className={OPTION_GROUP_CLASSNAME}>
      {children}
    </div>
  );
};

const RadioWrapper = ({ children }) => {
  return <div className="flex items-center gap-x-1.5">{children}</div>;
};

const RadioLabel = ({ children, ...props }) => {
  return (
    <Label isInline className="mb-0 w-full" {...props}>
      {children}
    </Label>
  );
};

const RadioInput = ({ value, name, disabled, ...props }) => (
  <input
    type="radio"
    className="h-[18px] w-[18px] text-primary border-gray-300 dark:border-border focus:ring-gray-300 dark:focus:ring-border focus:ring-2 "
    name={name}
    value={value}
    disabled={disabled}
    {...props}
  />
);

const Radio = {
  Group: RadioGroup,
  Wrapper: RadioWrapper,
  Label: RadioLabel,
  Input: RadioInput,
};

export default Radio;
